<chart class="chart-container" [options]="options"></chart>
<div *ngIf="titleTooltip" class="tooltip-title-wrapper">
  <achoo-icon-tooltip [tooltipMsg]="titleTooltip"></achoo-icon-tooltip>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-stacked-column-chart/achoo-stacked-column-chart.component.html